<div class="content-wrapper">
    <ng-template #content>
        <div id="modal">
            <div class="modal-header font-weight-bold">
                <h4 class="modal-title font-weight-bold">
                    Package confirmation
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="modalService.dismissAll('')">×
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="row p-10px">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h5>Are you sure you want to upgrade your package to {{selectedPackage?.name}} ?</h5>
                                <h5><b>Select Payment Mode?</b></h5>
                                <div class="form-check form-check-inline " style="padding-top: 5px;">
                                    <input class="form-check-input" type="radio" name="wallet" id="wallet"   value="wallet" [(ngModel)]="selectedPaymentMethod"  >
                                    <label class="form-check-label" for="wallet" style="font-size:15px;font-weight: bold;">
                                        Wallet
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="online" id="online"  value="online" [(ngModel)]="selectedPaymentMethod">
                                    <label class="form-check-label" for="online" style="font-size:15px;font-weight: bold;">
                                        Online
                                    </label>
                                </div>
                                <div class="row" *ngIf="selectedPaymentMethod === 'wallet'" style="padding-top: 5px;">
                                    <div class="col-12">
                                        <span>Your wallet Amount is: &#8377; {{userData?.wallet_amount | IndianNumber}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-10px">
                <button class="btn btn-sm btn-danger color-white mr-auto" (click)="modalService.dismissAll('')">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Cancel
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="upgradeFromWallet()" *ngIf="(selectedPaymentMethod === 'wallet') && !submitted_loader">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure
                </button>
                <button class="btn btn-sm btn-primary color-white"  *ngIf="(selectedPaymentMethod === 'wallet') && submitted_loader">
                    <i class="fa fa-spinner  mr-5px" aria-hidden="true"></i>Yes, Sure
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="upgradeFromOnline(selectedPackage?.user_package_amount)" *ngIf="(selectedPaymentMethod === 'online' && !submitted_loader)">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure
                </button>
                <button class="btn btn-sm btn-primary color-white"  *ngIf="(selectedPaymentMethod === 'online' &&  submitted_loader)">
                    <i class="fa fa-spinner mr-5px" aria-hidden="true"></i>Yes, Sure
                </button>
            </div>
        </div>
    </ng-template>
    <div class="content-body">
        <section id="package">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h2 class="mt-5px">Packages</h2>
                </div>
            </div>
            <div class="row mt-3">
                <div class="container-fluid">
                    <div class="row" *ngIf="packages && packages.length > 0; else alreadyOnHighestPackage">
                        <ng-container *ngFor="let pack of packages; let i = index">
                            <div class="col-xl-3 col-lg-3 col-md-3 colsm-3 col-xs-12" *ngIf="pack['user_package_amount'] > 0">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row shadow-bottom-light">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                <h5>{{pack?.name}}</h5>
                                            </div>
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                <h2>&#8377;{{pack?.user_package_amount | IndianNumber}}</h2>
                                            </div>
                                        </div>
                                        <div class="row mt-20px">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                <select class="form-control" (change)="getStockistPackage($event, pack,pack?.user_package_amount)">
                                                    <option value="">Choose Stockist</option>
                                                    <option [value]="stockist.unique_id" *ngFor="let stockist of stockists">{{stockist?.name}} ({{stockist?.username}})</option>
                                                </select>
                                            </div>
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-10px">
                                                <select class="form-control" (change)="chooseStockistPackage($event, pack)">
                                                    <option value="">Choose Package</option>
                                                    <option [value]="stockistPackage.product_id" *ngFor="let stockistPackage of pack['stockist_packages']">{{stockistPackage?.product?.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-footer text-center">
                                        <button class="btn btn-primary" (click)="upgradePackageModal(content, pack)">Upgrade Package</button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <ng-template #alreadyOnHighestPackage>
                        <div class="card">
                            <div class="card-body">
                                <h6>No Package to Purchase</h6>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </section>
    </div>
</div>
